<template>
    <q-tabs align="center" color="indigo-1">
        <q-route-tab v-for="menu in menus" :key="menu.name" v-ripple slot="title" :to="'/contents/'+menu.slug" >
            <img class="icon-tab" :src="menu.image_path">
            <span class="menu-name">{{ $T(menu.name) }}</span>
        </q-route-tab>
    </q-tabs>
</template>

<script>
    import { mapGetters } from 'vuex'
    import {
        QTabs,
        QRouteTab,
    } from 'quasar-framework'

    export default {
        components: {
            QTabs,
            QRouteTab,
        },

        computed: {
            ...mapGetters({
                menus: 'categories/user_categories'
            }),

            devFolder() {
                return window.config.devAssetsFolder
            },
        },
        methods:{
            redirectTo(url){
                window.open(url);
            }
        }
    }
</script>
<style lang="stylus" scoped>
    .icon-tab
        width 35px
    .icon
        width 30px
        height 30px
        display block
        background transparent no-repeat center center
        &-featured
            background-image url("../../img/icon-featured.svg")
        &-life
            background-image url("../../img/icon-life.svg")
        &-sports
            background-image url("../../img/icon-sports.svg")
        &-entertainment
            background-image url("../../img/icon-entertainment.svg")
        &-other
            background-image url("../../img/icon-other.svg")

</style>



// WEBPACK FOOTER //
// resources/assets/js/components/Footer.vue